import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
@Component({
  selector: 'app-manage-transactionroles',
  templateUrl: './manage-transactionroles.component.html',
  styleUrls: ['./manage-transactionroles.component.scss']
})
export class ManageTransactionRolesComponent implements OnInit {
  getTranRoleVm = {
    databaseID: 0,
    organizationId: 0,
    PageIndex: 0,
    PageSize: 10,
    searchValue: '' ,
    OfficeIDList:[],
    officeID:0   
  };

  deleteTranRoleVm = {
    transactionalRolesModels:[],
    databaseID: 0,
    organizationId: 0,
    userID: '',
    OfficeIDList:[],
    officeID:0   
  };

  formDialog: FormGroup;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
    OfficeIDList:[],
    officeID:0   
  };
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: any;
  organizationId: string;
  responseHolder: any;
  transactionroleList: any[]=[];  
  value = '';
  filterText: any;
  private _returnList: any;
  filteredList: any;
  totalCount: any;
  paginatorTotalLength: any;
  displayedColumns: string[] = [];
  dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;  

  editTransationRole = {
    transctionalRoleID:0,
    transactionalRoleName:'',
    organizationID:0,
    databaseID:0,
    userID:''
  }
  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
     private toastr: ToastrService, private statusConst: StatusConstant, 
     private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('transactionalRoleName', this.formBuilder.control(''));    
    this.getTransactionRoleList(this.pageModelData);
  }

  openDialogWithRef(templateRef: TemplateRef<any>, role: any) {
    this.editTransationRole.transctionalRoleID = role.transctionalRoleID;
    this.editTransationRole.transactionalRoleName = role.transactionalRoleName;
    this.editTransationRole.organizationID = Number(this.organizationId);
    this.editTransationRole.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.dialog.open(templateRef, {
    });
  }

  openDialogAddWithRef(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
    });
  }

  getTransactionRoleList(pageData: any) { 
    this.loaderService.show();   
    this.getTranRoleVm.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getTranRoleVm.organizationId = Number(this.organizationId);
    this.getTranRoleVm.PageIndex = pageData.pageIndex;
    this.getTranRoleVm.PageSize = pageData.pageSize;
    this.getTranRoleVm.searchValue = pageData.searchValue;
    this.getTranRoleVm.OfficeIDList=this.OfficeIDList;
    this.getTranRoleVm.officeID=this.myOfficeID;
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    this.settingsService.getAllTransactionRoles(this.getTranRoleVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.transactionroleList = this.responseHolder.data.transactionalRolesModels;
          this.paginatorTotalLength = this.responseHolder.data.totalCount;
          this.pageModelData.pageIndex = this.responseHolder.data.pageIndex;
          this.pageIndex = this.responseHolder.data.pageIndex;
          this.pageSize = pageData.pageSize;
          if(this.transactionroleList.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }     
        }
        else {
          this.ShowNoRecordFound=true;
          this.transactionroleList=[];
          this.paginatorTotalLength=0;
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.transactionroleList=[];
        this.paginatorTotalLength=0;
        this.loaderService.hide();
      }
    });
  }

  AddTransacrionRoleDetails(data) {
    this.loaderService.show();    
     let ReqModel = {
      transctionalRoleID: 0,
      transactionalRoleName: data.transactionalRoleName,
      organizationID: Number(this.organizationId),
      databaseID: parseInt(sessionStorage.getItem('databaseId')),
      UserId: this.currentUser.UID ,
      OfficeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,     
    }
    this.settingsService.AddTransactinalRole(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.data == true) {
          this.dialog.closeAll();
          this.toastr.success('Role added successfully.', '', {
            timeOut: 3000,
          });
          this.getTransactionRoleList(this.pageModelData);
          this.loaderService.hide();
        }
      }
    });
  }

  spinner:boolean=false;

  UpdateTransacrionRoleDetails() {
    this.spinner=true;
    this.formDialog.markAsPristine();
    let role = this.editTransationRole;
    this.loaderService.show();    
     let ReqModel = {
      transctionalRoleID: role.transctionalRoleID,
      transactionalRoleName: role.transactionalRoleName,
      organizationID: Number(this.organizationId),
      databaseID: parseInt(sessionStorage.getItem('databaseId')),
      UserId: this.currentUser.UID,
      OfficeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,           
    }
    this.settingsService.UpdateTransactinalRole(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.data == true) {
          this.dialog.closeAll();
          this.toastr.success('Role updated successfully.', '', {
            timeOut: 3000,
          });
          this.getTransactionRoleList(this.pageModelData);
          this.loaderService.hide();
        }
      }
    });
  }
   
  deleteTransactionRole(role: any) {
      var message = `Are you sure you want to delete?`;  
      const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData
      });  
      dialogRef.beforeClosed().subscribe(async dialogResult => {
        if (dialogResult) {
          this.loaderService.show();
          let pageData = this.pageModelData;
          this.deleteTranRoleVm.userID = this.currentUser.UID;
          this.deleteTranRoleVm.databaseID = parseInt(sessionStorage.getItem('databaseId'));
          this.deleteTranRoleVm.organizationId = Number(this.organizationId);
          var ReqModel ={
            transctionalRoleID: role.transctionalRoleID,
            transactionalRoleName:role.transactionalRoleName,
            OfficeIDList:this.OfficeIDList,
            officeID:this.myOfficeID,
          }
          this.deleteTranRoleVm.transactionalRolesModels.push(ReqModel);         
          this.settingsService.deleteTransactionRoles(this.deleteTranRoleVm).subscribe(response => {
            if (response != undefined) {
              this.responseHolder = response;
              this.loaderService.hide();
              if (this.responseHolder.data == 1) {
                this.toastr.success('Role deleted successfully.', '', {
                  timeOut: 3000,
                });
                this.getTransactionRoleList(this.pageModelData);
                this.loaderService.hide();
              }
            }
          });
        }
      });
  }    

  close() {
    this.formDialog.reset();
    this.dialog.closeAll();
  }

  Search(filterValue) {
    this.filterText = filterValue.trimLeft();
    this.pageModelData.searchValue = filterValue.trim();
    this.getTransactionRoleList(this.pageModelData);
  }

  clearFilter() {
    this.value = "";
    this.filterText = "";
    this.pageModelData.searchValue = this.filterText.trim();
    this.getTransactionRoleList(this.pageModelData);
  }

  CallNextPrevPageData(pageData: PageEvent) {
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue = this.value.trim();
    this.getTransactionRoleList(this.pageModelData);
  }
  

}
